import * as React from "react";
import type { SVGProps } from "react";
const SvgSkiLiftDrag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.06 6.35a1.01 1.01 0 0 0 1.29.59L11 5.947V20H9c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1h-2V5.198l3.36-1.258c.51-.2.77-.77.58-1.29-.2-.52-.77-.78-1.29-.59l-8.01 3c-.51.2-.77.77-.58 1.29"
    />
  </svg>
);
export default SvgSkiLiftDrag;
